import { trigger, state, style, transition, animate } from '@angular/animations';
/**
 * Function TdFadeInOutAnimation
 *
 * params:
 * * duration: Duration of animation in miliseconds. Defaults to 150 ms.
 *
 * Returns an [AnimationTriggerMetadata] object with states for a fading animation.
 *
 * usage: [@tdFadeInOut]="true|false"
 */
export function TdFadeInOutAnimation(duration) {
    if (duration === void 0) { duration = 150; }
    return trigger('tdFadeInOut', [
        state('0', style({
            opacity: '0',
            display: 'none',
        })),
        state('1', style({
            opacity: '*',
            display: '*',
        })),
        transition('0 => 1', animate(duration + 'ms ease-in')),
        transition('1 => 0', animate(duration + 'ms ease-out')),
    ]);
}
//# sourceMappingURL=fadeInOut.animation.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/core/common/animations/fade/fadeInOut.animation.js
// module id = ../../../../@covalent/core/common/animations/fade/fadeInOut.animation.js
// module chunks = 4